import React from 'react';
import { IframeTransmitterContext } from './IframeTransmitterContext';
import { WithIframeTransmitterType } from './types';

// ts hoc info https://react-typescript-cheatsheet.netlify.app/docs/hoc/full_example

export function withIframeTransmitter<P extends WithIframeTransmitterType = WithIframeTransmitterType>(
	Component: React.ComponentType<P>
) {
	function WithIframeTransmitter(props: Omit<P, keyof WithIframeTransmitterType>) {
		return (
			<IframeTransmitterContext.Consumer>
				{contexts => <Component {...(props as P)} {...contexts} />}
			</IframeTransmitterContext.Consumer>
		);
	}

	WithIframeTransmitter.displayName = `WithIframeTransmitter(${Component.displayName || Component.name})`;

	return WithIframeTransmitter;
}
